import { Controller } from "@hotwired/stimulus"

// Damage drawer opened without an asset (Schäden overview): the fields that only exist for one
// asset type — Versicherung for Fahrzeuge, "Defekt markieren" for Werkzeuge — follow the
// picked asset. Hidden sections are disabled too, so they never submit.
export default class extends Controller {
  static targets = ["picker", "section"]

  connect() {
    this.typeChanged()
  }

  typeChanged() {
    const type = this.pickerTarget.value.split(":")[0]
    this.sectionTargets.forEach((section) => {
      const shown = section.dataset.types.split(" ").includes(type)
      section.hidden = !shown
      section.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !shown
      })
    })
  }
}
